var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraftGigs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "19pt",
    height: "19pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#595757",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451 969 c-11 -18 -17 -38 -14 -46 7 -17 51 -63 60 -63 3 0 27 21 54 48 72 70 65 92 -32 92 -45 0 -51 -3 -68 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 890 l-52 -50 -180 0 -181 0 -29 -29 -29 -29 0 -362 0 -362 29 -29 29 -29 282 0 282 0 29 29 29 29 0 246 0 246 23 2 c12 0 34 0 49 -1 22 -2 27 3 33 28 13 60 9 90 -16 114 -13 13 -65 66 -115 118 -142 146 -122 138 -183 79z m-91 -245 l0 -105 105 0 105 0 0 -225 0 -225 -250 0 -250 0 0 330 0 330 145 0 145 0 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 375 l0 -45 170 0 170 0 0 45 0 45 -170 0 -170 0 0 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 215 l0 -45 170 0 170 0 0 45 0 45 -170 0 -170 0 0 -45z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftGigs);
export default __webpack_public_path__ + "static/media/DraftGigs.37e86719.svg";
export { ForwardRef as ReactComponent };